import { render, staticRenderFns } from "./AxisXLabel.vue?vue&type=template&id=a3b1b754&scoped=true"
import script from "./AxisXLabel.vue?vue&type=script&lang=js"
export * from "./AxisXLabel.vue?vue&type=script&lang=js"
import style0 from "./AxisXLabel.vue?vue&type=style&index=0&id=a3b1b754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b1b754",
  null
  
)

export default component.exports